/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react-native/no-color-literals */
import React from 'react';
import { View, ScrollView, TouchableOpacity, StyleSheet } from 'react-native';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import PropTypes from 'prop-types';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import { downloadFile } from '@global/helpers';

const SellOutReportDisplay = ({ reports = [] }) => {
  const EmptyState = () => (
    <View style={styles.emptyState}>
      <SociollaText style={styles.emptyText}>
        No sell-out reports found
      </SociollaText>
    </View>
  );

  const ReportCard = ({ report, index }) => {
    const fileName = `Attachment-${index + 1}`;

    return (
      <TouchableOpacity
        activeOpacity={0.85}
        style={styles.card}
        onPress={() => downloadFile(report.url, 'Report', '', true)}>
        <View style={styles.cardContent}>
          <View style={styles.textContainer}>
            <SociollaText type="bold" style={styles.fileName}>
              {fileName}
            </SociollaText>
            <SociollaText style={styles.fileType}>PDF Document</SociollaText>
          </View>

          <View style={styles.downloadIconContainer}>
            <Image
              style={styles.downloadIcon}
              width={28}
              height={28}
              isResolveAsset
              svg
              source={require('@/assets/img/icons/pdf-download.svg')}
            />
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <View
      testID="todo-sell-out-report-display-container"
      style={styles.wrapper}>
      <ScrollView
        contentContainerStyle={[
          styles.contentContainer,
          !reports.length && styles.emptyContainer,
        ]}
        showsVerticalScrollIndicator={false}
        alwaysBounceVertical>
        {!reports.length ? (
          <EmptyState />
        ) : (
          reports.map((report, idx) => (
            <ReportCard key={idx} report={report} index={idx} />
          ))
        )}
      </ScrollView>
    </View>
  );
};

SellOutReportDisplay.propTypes = {
  reports: PropTypes.array,
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    marginBottom: isWeb ? 30 : 0,
  },

  contentContainer: {
    padding: 20,
    paddingBottom: 32,
  },

  emptyContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },

  emptyState: {
    padding: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },

  emptyText: {
    color: Colors.grey1,
    fontSize: 14,
  },

  card: {
    backgroundColor: Colors.white,
    borderRadius: 12,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: Colors.grey0,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
    overflow: 'hidden',
  },

  cardContent: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
  },

  textContainer: {
    flex: 1,
  },

  fileName: {
    fontSize: 15,
    color: Colors.textSecondary,
    marginBottom: 4,
  },

  fileType: {
    fontSize: 12,
    color: Colors.grey2,
  },

  downloadIconContainer: {
    width: 50,
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
  },

  downloadIcon: {
    width: 28,
    height: 28,
    tintColor: Colors.blue0,
  },
});

export default SellOutReportDisplay;
